import { supabase } from "../../../infra_/supabase/supabaseClient.js";

export class EventStore {
  constructor(supabase) {
    this.supabase = supabase;
  }

  async save(event) {
    const registro = {
      event_name: event.eventName,
      aggregate_type: event.aggregateType,
      aggregate_id: event.aggregateId,
      payload: event.data,
      occurred_on: event.ocurrio,
    };

    const { error } = await this.supabase
      .from("event_store")
      .insert([registro]);

    if (error) {
      console.error("Error guardando evento:", error);
      throw error;
    }

    console.log("Evento guardado correctamente", registro);
  }
}

// Instancia exportada **después** de la clase
export const eventStore = new EventStore(supabase);